import React from "react";
import { getJobExtensionDays } from "@/lib/utils";
import { formatDateForDisplay } from "utils/utils";

const ExtendedJobNameCell = ({ getValue, row }) => {
  const name = getValue();
  const extensions = row?.original?.extensions || [];
  const extensionDate = extensions.length > 0 ? extensions[extensions.length - 1]?.date_created : null;
  const extensionDays = getJobExtensionDays(row.original);

  return (
    <div title={`${name}`} className="flex flex-col items-start">
      <span className="truncate font-medium">{name}</span>
      {extensionDays ? (
        <div className="text-red-600">
          Extended by {extensionDays} days last extended on {formatDateForDisplay(extensionDate)}
        </div>
      ) : null}
    </div>
  );
};

export default ExtendedJobNameCell;
